import styles from "./GuidedMenu.module.css";
// import "./GuidedMenuCard.css";
import React, { Component } from "react";

export default class GuidedMenuCard extends Component {
  constructor(props) {
    super(props);
    // callbackEvent=()=>{
    //   console.log("callback for ")
    // }
  }

  render() {
    let size = 12;
    // const font=this.props
    // const fontSize = font === "medium" ? "14px" : font === "large" ? "16px" : "12px";

    console.log("5555",this.props)
    // this.props.buttons.slice(0, size).map((item, i)
    // this.props.buttons.slice(0, size / 2).map((item, i)
    let buttons = this.props.buttons.slice(0, size).map((item, i) => (
      <button
        onClick={(e) => {
          e.preventDefault();
          if(item.target == 'faqmenu'){
            // console.log("ITEM from Guided Menu: ", item);
            // this.props.onTriggerWorkflow(item.targetId, item.name, item.target);
            this.props.onCallFaqMenu(item.targetId, item.name, item.target);
          } else {
            this.props.onCallback(item.targetId, item.name, item.target);
          }
        }}
        className={styles.option_button}
        key={i}
        // style={{fontSize:this.props.fontSize==="medium"?"10px":"" }}
      > 
        {item.name}
      </button>
    ));

    // let buttons1 = this.props.buttons
    //   .slice(size / 2 + 1, this.props.buttons.length)
    //   .map((item, i) => (
    //     <button
    //       onClick={(e) => {
    //         e.preventDefault();
    //         // console.log(
    //         //   item.name,
    //         //   "is clicked",
    //         //   item.targetId,
    //         //   "with id",
    //         //   item.target,
    //         //   "with target"
    //         // );
    //         this.props.onCallback(item.targetId, item.name, item.target);
    //       }}
    //       // className={styles.menu_button}
    //       className={styles.menu_button}
    //       key={i}
    //     >
    //       {item.name}
    //     </button>
    //   ));
    return <div className={styles.button_container}>{buttons}</div>;
    // return (
    //   <div className="row">
    //     <div className="col s6">{buttons}</div>
    //     <div className="col s6">{buttons1}</div>
    //   </div>
    // );
  }
}
